<template>
  <button
    :class=" transparentBg ? 'bg-headingColor opacity-50' :
            'bg-greyBackground z-20'"
    class="
      fixed
      inset-0
      w-full
      h-full
      overflow-y-hidden
      z-10
      cursor-default
    "
    @click="$emit('on-click')"
    tabindex="-1"
    type="button"
  ></button>
</template>
<script>
export default {
  name: 'Overlay',
  components: {},
  props: {
    transparentBg: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
  created() {
    const handleEscape = (e) => {
      if (e.key === 'Exc' || e.key === 'Escape') {
        this.$emit('on-click');
      }
    };
    document.addEventListener('keydown', handleEscape);
  },
  beforeUnmount() {
    const handleEscape = (e) => {
      if (e.key === 'Exc' || e.key === 'Escape') {
        this.$emit('on-click');
      }
    };
    document.removeEventListener('keydown', handleEscape);
  },
};
</script>
<style scoped>
</style>
